module.exports = __webpack_public_path__ + "img/skill_level_8_svg.0e5c44d1.svg";